/* global axios */
import ApiClient from './ApiClient';

class RelationshipAPI extends ApiClient {
  constructor() {
    super('relationships', { accountScoped: true });
  }

  validate({ entityType, items, page = 1 }) {
    return axios.post(`${this.url}/validate`, {
      entity_type: entityType,
      items,
      page,
    });
  }
}

export default new RelationshipAPI();
